import { useNavigate } from 'react-router-dom';
import BioSection from '../sections/BioSection';
import ExtrasSection from '../sections/ExtrasSection';
import MediaSection from '../sections/MediaSection';
import PersonalDetailsSection from '../sections/PersonalDetailsSection';
import SkillSection from '../sections/SkillSection';

function ProfileEditView({
  formData,
  handleChange,
  handleFileChange,
  handleSubmit,
  isLoadingProfile,
  isSavingProfile,
  manageListItem,
  onRefreshProfile,
  statusMessage,
  toggleAddOn,
  toggleSkillTag,
  updateAddOnField,
}) {
  const navigate = useNavigate();
  const effectiveStatusMessage = statusMessage;



  const onSubmit = async (event) => {
    await handleSubmit(event);
  };


  return (
    <div className="row g-4 justify-content-center">
      <div className="col-xl-12 col-lg-12">
        <div className="d-grid gap-4">
          <form className="card shadow-sm border-0" onSubmit={onSubmit}>
            <div className="card-body">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-4">
                <div>
                  <h2 className="h4 mb-1">Edit Profile</h2>
                  <p className="text-muted small mb-1">Update your player profile details.</p>
                  {isLoadingProfile && <p className="text-muted small mb-0">Loading your saved profile...</p>}
                </div>
              </div>

              <PersonalDetailsSection data={formData.personal} onChange={handleChange} />
              <SkillSection data={formData.skills} onChange={handleChange} onToggleSkill={toggleSkillTag} />
              <BioSection data={formData.bio} onChange={handleChange} />
              <div className="card border-0 bg-light mb-4">
                <div className="card-body py-3 px-3 px-md-4 d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3">
                  <div>
                    <h3 className="h6 mb-1">Affiliation</h3>
                    <p className="text-muted small mb-0">
                      Manage your organizations, clubs, communities, primary selections, and approver preferences from the dedicated affiliation page.
                    </p>
                  </div>
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    onClick={() => navigate('/account/affiliation')}
                  >
                    Manage Affiliation
                  </button>
                </div>
              </div>
              <MediaSection data={formData.media} onFileChange={handleFileChange} />
              <ExtrasSection
                formData={formData}
                onToggleAddOn={toggleAddOn}
                onAddOnFieldChange={updateAddOnField}
                onManageListItem={manageListItem}
              />

              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 pt-3 border-top">
                {effectiveStatusMessage && (
                  <div className="d-grid gap-2">
                    <div className="alert alert-info mb-0 py-2 px-3" role="status">
                      {effectiveStatusMessage}
                    </div>
                  </div>
                )}
                <div className="d-flex flex-column flex-sm-row gap-2 ms-sm-auto">
                  {onRefreshProfile && (
                    <button
                      className="btn btn-outline-primary"
                      type="button"
                      onClick={onRefreshProfile}
                      disabled={isLoadingProfile}
                    >
                      {isLoadingProfile ? 'Refreshing...' : 'Refresh stats'}
                    </button>
                  )}
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => navigate('/profile')}
                    disabled={isLoadingProfile}
                  >
                    Cancel
                  </button>
                  <button className="btn btn-primary" type="submit" disabled={isLoadingProfile || isSavingProfile}>
                    {isSavingProfile ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ProfileEditView;
